export default "__VITE_ASSET__b0e5f0fb__"